// packages block
import { createMuiTheme } from "@material-ui/core/styles";
// constants block
import {INTER} from ".";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#5ec9e9",
    },
    secondary: {
      light: "#0066ff",
      main: "#0044ff",
      contrastText: "#ffcc00",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },

  shape: {
    borderRadius: 0,
  },

  typography: {
    fontFamily: INTER,

    h1: {
      fontSize: "1.56vw",
      fontWeight: 700
    },

    h2: {
      fontSize: "1.35vw",
      fontWeight: 700
    },

    h3: {
      fontSize: "1.04vw",
      fontWeight: 700
    },

    h4: {
      fontSize: "1.1vw",
      fontWeight: 700
    },

    h5: {
      fontSize: "0.84vw",
      fontWeight: 700
    },

    h6: {
      fontSize: "0.92vw",
      fontWeight: 700
    },

    body1: {
      fontSize: "0.85vw",
      fontWeight: 700
    },

    body2: {
      fontSize: "0.7vw",
    },
  },

  overrides: {
    MuiCheckbox: {
      colorSecondary: {

        '&$checked': {
          color: '#04acdd',
        },
      },
    },

    MuiTableRow: {
      root: {
        padding: '3px 0px',
        borderBottom: "1px solid lightgray"
      }
    },

    MuiTableCell: {
      root: {
        padding: 10, 
        fontSize: "0.85vw",
        fontWeight: 700
      }
    },
    
    MuiAlert: {

      action: {
        '&>button': {
          height: 'auto'
        }
      }

    }

  },
});
